// Makes near-white pixels transparent so logos sit crisply on colored backgrounds.
export function removeWhiteBackground(dataUrl, { threshold = 232, soft = 24 } = {}) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const c = document.createElement('canvas');
      c.width = img.naturalWidth; c.height = img.naturalHeight;
      const ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const id = ctx.getImageData(0, 0, c.width, c.height);
      const d = id.data;
      for (let i = 0; i < d.length; i += 4) {
        const min = Math.min(d[i], d[i + 1], d[i + 2]);
        if (min >= threshold) {
          d[i + 3] = 0;
        } else if (min >= threshold - soft) {
          d[i + 3] = Math.round(d[i + 3] * (1 - (min - (threshold - soft)) / soft));
        }
      }
      ctx.putImageData(id, 0, 0);
      resolve(c.toDataURL('image/png'));
    };
    img.onerror = () => resolve(dataUrl);
    img.src = dataUrl;
  });
}

export function readFileAsDataUrl(file) {
  return new Promise((resolve) => { const r = new FileReader(); r.onload = (e) => resolve(e.target.result); r.readAsDataURL(file); });
}
